export default __webpack_public_path__ + "static/media/GIF_3.bb45084f.mp4";